import React, {
  useEffect,
  useState
} from 'react';

import {
  faCaretSquareDown,
  faCaretSquareUp
} from '@fortawesome/free-regular-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';

import {
  Tooltip
} from 'antd';

import OlLayerBase from 'ol/layer/Base';
import OlLayerGroup from 'ol/layer/Group';
import OlLayerImage from 'ol/layer/Image';
import OlLayerTile from 'ol/layer/Tile';
import OlSourceImageWMS from 'ol/source/ImageWMS';
import OlSourceTileWMS from 'ol/source/TileWMS';

import {
  useTranslation
} from 'react-i18next';

import {
  MapUtil
} from '@terrestris/ol-util/dist/MapUtil/MapUtil';

import useMap from '@terrestris/react-geo/dist/Hook/useMap';
import Legend from '@terrestris/react-geo/dist/Legend/Legend';
import {
  isWmsLayer
} from '@terrestris/react-geo/dist/Util/typeUtils';

import './index.less';

export type LayerTreeNodeProps = {
  layer: OlLayerBase;
};

export const LayerTreeNode: React.FC<LayerTreeNodeProps> = ({
  layer
}): JSX.Element => {

  const [legendVisible, setLegendVisible] = useState(false);

  const map = useMap();

  const {
    t
  } = useTranslation();

  useEffect(() => {
    layer.set('legendVisible', legendVisible);
  }, [layer, legendVisible]);

  if (!map) {
    return <></>;
  }

  const onToggleLegendClick = () => {
    setLegendVisible(!legendVisible);
  };

  const mapView = map.getView();
  const unit = mapView.getProjection().getUnits() || 'm';
  const resolution = mapView.getResolution();
  const scale = resolution ? MapUtil.getScaleForResolution(resolution, unit) : undefined;

  if (layer instanceof OlLayerGroup) {
    return (
      <span>
        {layer.get('name')}
      </span>
    );
  } else {
    return (
      <div
        className="layer-tree-node"
      >
        {
          (isWmsLayer(layer) && layer.get('visible')) &&
          <Tooltip
            title={legendVisible ?
              t('LayerTreeNode.toggleLegendTooltipHideTitle') :
              t('LayerTreeNode.toggleLegendTooltipShowTitle')
            }
            mouseEnterDelay={0.5}
          >
            <FontAwesomeIcon
              className="toggle-legend"
              icon={legendVisible ?
                faCaretSquareUp :
                faCaretSquareDown
              }
              onClick={onToggleLegendClick}
            />
          </Tooltip>
        }
        <span>
          {layer.get('name')}
        </span>
        {
          (legendVisible && layer.get('visible') && isWmsLayer(layer)) &&
          <Legend
            layer={layer as OlLayerImage<OlSourceImageWMS> | OlLayerTile<OlSourceTileWMS>}
            errorMsg={t('LayerTreeNode.noLegendAvailable')}
            extraParams={{
              scale,
              LEGEND_OPTIONS: 'fontAntiAliasing:true;forceLabels:on',
              TRANSPARENT: true
            }}
          />
        }
      </div>
    );
  }
};

export default LayerTreeNode;
